import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, } from 'react-bootstrap';
import Logo from '../assets/images/logo-icon.svg'
import Logo1 from '../assets/images/logo.png'
import Email from '../assets/images/email.png'
import Lock from '../assets/images/lock.png'
import CustomButton from '../common/CustomButton';
import { apiRequest } from '../utils/config/apiRequest';
import { _apiUrls } from '../utils/endpoints/apiUrls';
import { useNavigate } from 'react-router-dom';
import { setAuthCookie, setUserLocal } from '../utils/helpers/authHelpers';
import { setAuth } from '../redux/slicers/auth';
import { useDispatch } from 'react-redux';
import { updateUser } from '../redux/slicers/user';
import Cookies from 'js-cookie';
import CustomModal from '../common/CustomModal';
import TextField from '../common/TextFeild';

const LoginPage = () => {

    const [modal, setModal] = useState(false)

    const [state, setState] = useState({
        email: '',
        password: '',
    })
    const [error, setError] = useState({
        email: '',
        password: '',
    });
    const [forgotState, setForgotState] = useState({
        email: '',
        error: '',
        loading: false
    });
    const [rememberMe, setRememberMe] = useState(false);


    const [load, setLoad] = useState(false)
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const handleLogin = async () => {
        const newError = {
            email: state?.email ? '' : 'Email is required',
            password: state?.password ? '' : 'Password is required',
        };

        setError(newError);

        if (newError.email || newError.password) return;

        setLoad(true)
        const reqdata = {
            email: state?.email,
            password: state?.password
        }

        // Remember in Cookies -----------------------------------------

        if (rememberMe) {
            Cookies.set('rememberEmail', reqdata?.email, { expires: 7 });
            Cookies.set('rememberPassword', reqdata?.password, { expires: 7 });
        } else {
            Cookies.remove('rememberEmail');
            Cookies.remove('rememberPassword');
        }

        const { data, status } = await apiRequest({
            endUrl: _apiUrls.userLogin,
            method: 'POST',
            body: reqdata,
            showMsg: true
        })
        setLoad(false)
        if (status) {
            setAuthCookie(data?.user?.token)   // Save token in cookie
            setUserLocal(data?.user)
            dispatch(setAuth({ token: data?.user?.token, isAuth: true, userType: data?.user?.userType })) // Save token in Redux
            dispatch(updateUser(data?.user));
            navigate('/dashboard');
        }
    }

    useEffect(() => {
        const remeberedEmail = Cookies.get('rememberEmail');
        const rememberPassword = Cookies.get('rememberPassword');
        if (remeberedEmail && rememberPassword) {
            setState({ email: remeberedEmail, password: rememberPassword })
            setRememberMe(true)
        }
    }, [])

    const handleForgotPassword = async () => {
        if (!forgotState.email) {
            setForgotState(prev => ({ ...prev, error: 'Email is required' }));
            return;
        }

        setForgotState(prev => ({ ...prev, loading: true, error: '' }));

        const { status } = await apiRequest({
            endUrl: _apiUrls.forgotPassword,
            method: 'POST',
            body: { email: forgotState.email },
            showMsg: true,
        });
        if (status) {
            setModal(false);
            setForgotState({ email: '', error: '', loading: false });
        }
    };


    return (
        <>
            <Container fluid className="login-page">
                <Row className="vh-100">
                    {/* Left Section */}
                    <Col md={7} className="d-flex order-sm-1 order-2 flex-column justify-content-center align-items-center left-section py-4">
                        <img src={Logo} alt="Logo" className="mb-2 logo-img mt-auto" />
                        <h1>Just Push It.</h1>
                        <p>Stay informed instantly with our app!</p>
                        <footer className="mt-auto privacypolicy">
                            <span>© 2025 All rights Reserved</span>
                            <a href="/" className="privacypolicy" style={{ marginLeft: '60px' }}>Privacy Policy</a>
                        </footer>
                    </Col>

                    {/* Right Section */}
                    <Col md={5} className="align-items-start order-sm-2 order-1 px-sm-5 px-3 bg-white">
                        <Row className="px-4">
                            <Col md={12}>
                                <div className="mt-sm-5 mt-5">
                                    <img src={Logo1} alt="Mini Logo" className="logoimg" style={{ height: "60px" }} />
                                </div>

                            </Col>

                            <Col md={12}>
                                <div className="mt-sm-5 mt-4">
                                    <h2 className="heading">Welcome Back,</h2>
                                    <p className="subheading">Hey, back to your special place!</p>
                                </div>
                            </Col>

                            <Col md={12} className="mt-sm-5 mt-4 mb-sm-4 mb-3">
                                <TextField
                                    icon={Email}
                                    placeholder="Enter email"
                                    value={state?.email}
                                    onChange={(e) => setState({ ...state, email: e.target.value })}
                                />
                                {error.email && <p className='mb-0 mt-1' style={{ color: 'red', fontSize: '13px' }}>{error.email}</p>}
                            </Col>
                            <Col md={12}>
                                <TextField
                                    icon={Lock}
                                    placeholder="Passcode"
                                    value={state?.password}
                                    type="password"
                                    onChange={(e) => setState({ ...state, password: e.target.value })}
                                    isPassword={true}
                                />
                                {error.password && <p className='mb-0 mt-1' style={{ color: 'red', fontSize: '13px' }}>{error.password}</p>}
                            </Col>
                        </Row>

                        <Row className='mt-3 px-4'>
                            <Col md={6} xs={6}>
                                <Form.Check
                                    type="checkbox"
                                    className="custom-checkbox"
                                    label={<span className="checkbox-label">Remember Me</span>}
                                    checked={rememberMe}
                                    onChange={(e) => setRememberMe(e.target.checked)}
                                />
                            </Col>

                            <Col md={6} xs={6} className='text-end'>
                                <p className='mb-0' href="#" style={{ textDecoration: 'none', cursor: 'pointer' }} onClick={() => setModal(true)}>
                                    <span className='forget-text'>Forgot Password?</span>
                                </p>
                            </Col>

                            <Col md={12} className='mt-sm-4 mt-4 pb-5'>
                                <CustomButton variant="contained3"
                                    text={
                                        load ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Signing In...
                                            </>
                                        ) : (
                                            "Sign In"
                                        )
                                    }
                                    className='containebtn'
                                    onClick={handleLogin}
                                    disabled={load}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>


            {/* Forgot Password Modal -------------------------------------- */}

            <CustomModal
                show={modal}
                onHide={() => setModal(false)}
                title="Forgot Password"
                showCloseButton={true}
                footerButtons={
                    <div style={{ display: 'flex', marginTop: 10, justifyContent: 'flex-start', gap: '10px', width: '100%' }}>
                        <Button
                            variant="secondary"
                            style={{
                                backgroundColor: "rgba(75, 128, 235, 1)",
                                borderColor: "rgba(75, 128, 235, 1)",
                                padding: "8px 30px",
                                borderRadius: 10
                            }}
                            onClick={handleForgotPassword}
                        >
                            Send
                        </Button>
                    </div>
                }
            >
                <Row className='mt-2'>
                    <Col md={12}>
                        <p className='text-center' style={{ fontSize: 14, fontWeight: 500, color: '#ffffff' }}>Enter your registered email to receive reset instructions</p>
                    </Col>

                    <Col md={12}>
                        <p className='mb-1 input-label f-14'>Email Id</p>
                        <TextField
                            style={{
                                padding: "9px 11px",
                                borderRadius: "10px",
                                background: ''
                               
                            }}
                            className="white-on-focus"
                            placeholder='Enter Email'
                            value={forgotState.email}
                            onChange={(e) => setForgotState({ ...forgotState, email: e.target.value })}
                        />
                        {forgotState.error && <p style={{ color: 'red', fontSize: '13px', marginTop: 6 }}>{forgotState.error}</p>}
                    </Col>
                </Row>
            </CustomModal>

        </>



    );
};

export default LoginPage;
